<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 table-overlay">
        <div class="block block-mode-hidden">
          <div v-if="tableLoader && showLoader" class="overlay"></div>
          <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#5C7FD1" loading="loading" size="40" sizeUnit="px"></hash-loader>
          <div class="block-header bg-primary">
            <h3 class="block-title text-white">
              <i class="fa fa-clock"></i> Completed History ({{ completedTodoList ? Object.keys(completedTodoList).length : 0 }})
              <span class="hash-loader" v-if="showLoader && !tableLoader">
                <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
              </span>
            </h3>
            <div class="block-options">
              <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
            </div>
          </div>
          <div class="block-content block-content-full table-overview">
            <div>
              <table id="history" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
                <thead>
                  <tr>
                    <th class="text-center">ID</th>
                    <th class="text-center">Name</th>
                    <th class="text-center">Completed</th>
                  </tr>
                </thead>
                <tbody>
                  {{ todoList }}
                  <tr v-for="(completed, index) in completedTodoList" :key="index">
                    <td class="text-center font-size-sm">{{ completed.id }}</td>
                    <td class="font-w600 font-size-sm">{{ completed.name }}</td>
                    <td>
                      {{ completed.dueDate }} <small class="text-muted">({{ completed.addedTimeAgo }})</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 table-overlay">
        <div class="datatables">
          <div class="block block-mode-hidden">
            <div v-if="tableLoader && showLoader" class="overlay"></div>
            <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#4EC37B" loading="loading" size="40" sizeUnit="px"></hash-loader>
            <div class="block-header bg-success">
              <h3 class="block-title text-white">
                <i class="fa fa-broadcast-tower"></i> Active ({{ activeTodoList ? Object.keys(activeTodoList).length : 0 }})
                <span class="hash-loader" v-if="showLoader && !tableLoader">
                  <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                </span>
              </h3>
              <button type="button" class="btn-block-option text-white" href="#add_reminder" data-toggle="modal">
              <i v-bind:disabled="showLoader" class="si si-plus"></i> Add new reminder
              </button>
              <div class="block-options">
                <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
              </div>
            </div>
          <div class="block-content block-content-full table-overview">
            <div>
              <table id="active-reminders" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
                <thead>
                  <tr>
                    <th class="text-center no-sorting">
                      <div class="custom-control custom-checkbox text-center">
                        <input type="checkbox" v-model='activeBulkChange' @click="selectAll('active-todos')" class="custom-control-input" id="active-todos-bulk-action">
                        <label class="custom-control-label" for="active-todos-bulk-action"></label>
                      </div>
                    </th>
                    <th class="text-center">ID</th>
                    <th class="text-center">Name</th>
                    <th class="text-cente">Status</th>
                    <th class="text-center no-sorting">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="active in activeTodoList" :key="active.id">
                    <td lass="text-center font-size-sm">
                      <div class="custom-control custom-checkbox text-center multi-select active-todos">
                        <input type="checkbox" @click.exact="deselect('active-todos')" v-model="selectedActiveList" :value="active.id" :id="`data-${active.id}`" class="custom-control-input">
                        <label class="custom-control-label" :for="`data-${active.id}`"></label>
                      </div>
                    </td>
                    <td class="text-center font-size-sm">{{ active.id }}</td>
                    <td class="font-w600 font-size-sm text-center">{{ active.name }}</td>
                    <td class="text-center">
                      <span v-if="active.startDate <= todayDate">
                        <i class="fa fa-check text-success" title="active"></i> {{ active.status }}
                      </span>
                      <span v-else>
                        <i class="far fa-clock text-success" title="upcoming"></i> upcoming
                      </span>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-danger btn-sm" @click.prevent="remove(active.id)">
                      <i class="fa fa-trash-alt text-white"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 action">
                    <select class="form-control form-control-alt" v-model="activeAction" @change="bulkOperation(selectedActiveList, activeAction, 'active', () => { activeAction = 0; selectedActiveList = []; activeBulkChange = 0; })">
                    <option value="0" disabled="disabled">Select action</option>
                    <option value="1">Change status</option>
                    <option value="2">Delete</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 table-overlay">
        <div class="datatables">
          <div class="block block-mode-hidden">
            <div v-if="tableLoader && showLoader" class="overlay"></div>
            <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#F3B65F" loading="loading" size="40" sizeUnit="px"></hash-loader>
            <div class="block-header bg-warning">
              <h3 class="block-title text-white">
                <i class="fa fa-broadcast-tower"></i> Inactive ({{ inactiveTodoList ? Object.keys(inactiveTodoList).length : 0 }})
                <span class="hash-loader" v-if="showLoader && !tableLoader">
                  <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                </span>
              </h3>
              <div class="block-options">
                <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
              </div>
            </div>
          <div class="block-content block-content-full table-overview">
            <div>
              <table id="inactive-reminders" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
                <thead>
                  <tr>
                    <th class="text-center no-sorting">
                      <div class="custom-control custom-checkbox text-center">
                        <input type="checkbox" v-model='inactiveBulkChange' @click="selectAll('inactive-todos')" class="custom-control-input" id="inactive-todos-bulk-action">
                        <label class="custom-control-label" for="inactive-todos-bulk-action"></label>
                      </div>
                    </th>
                    <th class="text-center">ID</th>
                    <th class="text-center">Name</th>
                    <th class="text-center no-sorting">Status</th>
                    <th class="text-center no-sorting">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="inactive in inactiveTodoList" :key="inactive.id">
                    <td lass="text-center font-size-sm">
                      <div class="custom-control custom-checkbox text-center multi-select inactive-todos">
                        <input type="checkbox" @click.exact="deselect('inactive-todos')" v-model="selectedInactiveList" :value="inactive.id" :id="`data-${inactive.id}`" class="custom-control-input">
                        <label class="custom-control-label" :for="`data-${inactive.id}`"></label>
                      </div>
                    </td>
                    <td class="text-center font-size-sm">{{ inactive.id }}</td>
                    <td class="font-w600 font-size-sm text-center">{{ inactive.name }}</td>
                    <td class="text-center">
                      <i class="fa fa-ban text-warning" title="inactive"></i>
                      {{ inactive.status }}
                    </td>
                    <td class="text-center">
                      <button class="btn btn-danger btn-sm" @click.prevent="remove(inactive.id)">
                      <i class="fa fa-trash-alt text-white"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 action">
                    <select class="form-control form-control-alt" v-model="inActiveAction" @change="bulkOperation(selectedInactiveList, inActiveAction, 'inactive', () => { inActiveAction = 0; selectedInactiveList = []; inactiveBulkChange = 0; })">
                    <option value="0" disabled="disabled">Select action</option>
                    <option value="1">Change status</option>
                    <option value="2">Delete</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 table-overlay">
        <div class="datatables">
          <div class="block block-mode-hidden">
            <div v-if="tableLoader && showLoader" class="overlay"></div>
            <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#70B9EB" loading="loading" size="40" sizeUnit="px"></hash-loader>
            <div class="block-header bg-info">
              <h3 class="block-title text-white">
                <i class="fa fa-broadcast-tower"></i> Late ({{ lateTodoList ? Object.keys(lateTodoList).length : 0 }})
                <span class="hash-loader" v-if="showLoader && !tableLoader">
                  <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                </span>
              </h3>
              <div class="block-options">
                <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
              </div>
            </div>
          <div class="block-content block-content-full table-overview">
            <div>
              <table id="late-reminders" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
                <thead>
                  <tr>
                    <th class="text-center no-sorting">
                      <div class="custom-control custom-checkbox text-center">
                        <input type="checkbox" v-model="lateBulkChange" @click="selectAll('late-todos')" class="custom-control-input" id="late-todos-bulk-action">
                        <label class="custom-control-label" for="late-todos-bulk-action"></label>
                      </div>
                    </th>
                    <th class="text-center">ID</th>
                    <th class="text-center">Name</th>
                    <th class="text-center no-sorting">Status</th>
                    <th class="text-center no-sorting">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="late in lateTodoList" :key="late.id">
                    <td lass="text-center font-size-sm">
                      <div class="custom-control custom-checkbox text-center multi-select late-todos">
                        <input type="checkbox" @click.exact="deselect('late-todos')" v-model="selectedLateList" :value="late.id" :id="`data-${late.id}`" class="custom-control-input">
                        <label class="custom-control-label" :for="`data-${late.id}`"></label>
                      </div>
                    </td>
                    <td class="text-center font-size-sm">{{ late.id }}</td>
                    <td class="font-w600 font-size-sm text-center">{{ late.name }}</td>
                    <td class="text-center">
                      <i class="far fa-clock text-warning" title="inactive"></i>
                      {{ late.status }}
                    </td>
                    <td class="text-center">
                      <button class="btn btn-danger btn-sm" @click.prevent="remove(late.id)">
                      <i class="fa fa-trash-alt text-white"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 action">
                    <select class="form-control form-control-alt" v-model="lateAction" @change="bulkOperation(selectedLateList, lateAction, 'late', () => { lateAction = 0; selectedLateList = []; lateBulkChange = 0 })">
                    <option value="0" disabled="disabled">Select action</option>
                    <option value="1">Change status</option>
                    <option value="2">Delete</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateReminderStatus
      ref="updateStatus"
      @refreshList="fetch"
      @showSuccessMsg="displaySuccessMsg"
    ></UpdateReminderStatus>
    <RemoveReminder
      ref="removeReminder"
      @refreshList="fetch"
      @showSuccessMsg="displaySuccessMsg"
    ></RemoveReminder>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import AlertMessageModal from '@/components/AlertMessageModal';
import UpdateReminderStatus from '@/components/modals/UpdateReminderStatus';
import RemoveReminder from '@/components/modals/RemoveReminder';
import $ from 'jquery';
Vue.use(VueSpinners);

export default {
  name: 'Reminder',
  data() {
    return {
      completedTodoList: [],
      activeTodoList: [],
      inactiveTodoList: [],
      lateTodoList: [],
      isTableEnabled: false,
      showLoader: false,
      selectedActiveList: [],
      selectedInactiveList: [],
      selectedLateList: [],
      lateAction: 0,
      activeAction: 0,
      inActiveAction: 0,
      activeBulkChange: false,
      inactiveBulkChange: false,
      lateBulkChange: false,
      tableLoader: false,
      doClickProcess: true,
      todayDate: new Date().toJSON().slice(0,10),
      types: ['active', 'inactive', 'late']
    };
  },
  created() {
    this.fetch(false);
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
    this.loadFile('/static/js/oneui.app.min.js', 'js');
    this.loadFile('/static/js/be_tables_datatables.min.js', 'js');
  },
  components: {
    AlertMessageModal,
    HashLoader,
    UpdateReminderStatus,
    RemoveReminder
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    todoList() {
      if (this.$store.state.library.allTodoList) {
        return this.enableDataTable(this.$store.state.library.allTodoList);
      }
    }
  },
  methods: {
    ...mapActions('library', ['getAllTodoList']),
    ...mapGetters('library', ['getTodoList']),
    ...mapActions('alert', ['success', 'error', 'clear']),
    async fetch(force) {
      if (force || this.getTodoList() === null) {
        this.showLoader = true;
        await this.getAllTodoList();
      }
      if (this.getTodoList() === null) {
        this.enableDataTable([{completed: [], active: [], inactive: [], late: []}]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#history').DataTable();
        table.destroy();
        table = jQuery('#active-reminders').DataTable();
        table.destroy();
        table = jQuery('#inactive-reminders').DataTable();
        table.destroy();
        table = jQuery('#late-reminders').DataTable();
        table.destroy();
      }
      vm.completedTodoList = data.completed;
      vm.activeTodoList = data.active;
      vm.inactiveTodoList = data.inactive;
      vm.lateTodoList = data.late;
      helper.prepareDataTable('#history', 5);
      helper.prepareDataTable('#active-reminders', 5);
      helper.prepareDataTable('#inactive-reminders', 5);
      helper.prepareDataTable('#late-reminders', 5);
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    selectAll(className) {
      this.doClickProcess = false;
      let bulkStatus = jQuery('input#' + className + '-bulk-action').is(':checked');
      if (bulkStatus) {
        jQuery('.' + className + ' input[type="checkbox"]:checked').trigger('click');
      }
      jQuery('.' + className + ' input[type="checkbox"]').trigger('click');
      this.doClickProcess = true;
    },
    deselect(className) {
      if (!this.doClickProcess) {
        return;
      }

      let bulkStatus = jQuery('input#' + className + '-bulk-action').is(':checked');
      if (bulkStatus) {
        jQuery('input#' + className + '-bulk-action').prop('checked', false);
      }
    },
    bulkOperation(selectedList, action, status, callback) {
      if (selectedList.length === 0) {
        this.error('Please select some entries.');
        this.triggerMessageModal('#alert_modal');
        callback();
        return;
      }

      let headerColor;
      switch (status) {
        case 'late':
          headerColor = 'bg-info';
          break;
        case 'active':
          headerColor = 'bg-success';
          break;
        default:
          headerColor = 'bg-warning';
          break;
      }
      if (selectedList.length && action === '1') {
        this.$refs.updateStatus.setSelectedId(selectedList);
        this.$refs.updateStatus.setCallback(callback);
        this.$refs.updateStatus.setCurrentStatus(status);
        this.$refs.updateStatus.setHeaderColor(headerColor);
        jQuery('#reminder-status').modal('show');
      }
      if (selectedList.length && action === '2') {
        this.$refs.removeReminder.setSelectedId(selectedList);
        this.$refs.removeReminder.setCallback(callback);
        this.$refs.removeReminder.setHeaderColor(headerColor);
        jQuery('#remove-reminder').modal('show');
      }
    },
    displaySuccessMsg(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    remove(id) {
      this.$refs.removeReminder.setSelectedId([id]);
      this.$refs.removeReminder.setCallback(null);
      jQuery('#remove-reminder').modal('show');
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/Reminder.vue